<template>
  <div class="admin-tab">
    <wb-datatable
      v-bind="tableProps"
      @addEmit="openDialog"
      @editEmit="openDialog"
      @deleteEmit="openConfirmDialog"
      :searchKey="'tagName'"
      
    ></wb-datatable>
    <md-dialog ref="dialog">
      <md-dialog-title>{{isNew ? 'Create authorization config' : 'Update authorization config'}}</md-dialog-title>
      <md-dialog-content>
        <form>
          <md-input-container>
            <label>Name</label>
            <md-input v-model="name"></md-input>
          </md-input-container>

          <md-input-container>
            <label>Tag Name</label>
            <md-input v-model="tagName"></md-input>
          </md-input-container>

          <md-input-container>
            <multiselect id="strategy"
                v-model="selectedStrategy"
                :options="strategyOptions"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                placeholder="Strategy"
            >
            </multiselect>
          </md-input-container>

          <md-input-container>
            <multiselect id="strategyType"
                v-model="selectedStrategyType"
                :options="strategyTypeOptions"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                placeholder="Strategy Type"
            >
            </multiselect>
          </md-input-container>

          <md-input-container>
            <label>Options JSON</label>
            <md-textarea v-model="authOptions"></md-textarea>
          </md-input-container>

        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
        <md-button class="md-primary" :disabled="name==='' || tagName==='' || !selectedStrategy || !selectedStrategyType || !authOptions" @click="closeDialog(true)">{{isNew ? 'Create' : 'Update'}}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog ref="confirmDialog">
      <md-dialog-title>Are you sure you would like to remove this configuration?</md-dialog-title>
        <md-dialog-content>
          <b>Name</b>: {{currentRow ? currentRow.name : ''}}<br>
          <b>Tag Name</b>: {{currentRow ? currentRow.tagName : ''}}<br>
          <b>Strategy</b>: {{currentRow ? currentRow.strategy : ''}}<br>
          <b>Strategy Type</b>: {{currentRow ? currentRow.strategyType : ''}}<br>
          <b>Options</b>: {{currentRow ? currentRow.options : ''}}<br>
        </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>


  </div>
</template>

<script>
import wbDataTable from 'WBDataTable';
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import _ from 'underscore';
import managedata from '../../helpers/managedata';


export default {
  name: 'AdminRoles',
  components: {
    'wb-datatable': wbDataTable,
    Multiselect,
  },
  data() {
    return {
      role: null,
      selectedStrategy: null,
      selectedStrategyType : null,
      authOptions: null,
      tagName: null,
      name: null,
      isNew: false,
      currentRow: null,
      currentId: null,
      strategyTypeOptions: [],
      strategyOptions: [],
      tableProps: {
        dataext: [],
        columns:[
          {name: 'name', displayName: 'Name', visible: true, type:'string', isEditable:false},
          {name: 'tagName', displayName: 'Tag Name', visible: true, type:'string', isEditable:false},
          {name: 'strategy', displayName: 'Strategy', visible: true, type:'string', isEditable:false},
          {name: 'strategyType', displayName: 'Strategy Type', visible: true, type:'string', isEditable:false},
          {name: 'options', displayName: 'Options', visible: true, type:'string', isEditable:false},
        ],
        hasControls: true,
        allowCreation: true,
        disableSearch: false,
        pagination: {
          size: 50
        },
      },
      roles: null
    }
  },
  watch: {},
  validations: {},
  computed: {
  },
  methods: {
    parseAuthConfigs() {
      this.tableProps.dataext = [];
      managedata.getAuthConfigs()
      .then(res => {
        if(res && res.body){
          res.body.forEach((val)=>{
            this.tableProps.dataext.push({
              name: val.name,
              tagName: val.tagName,
              strategy: val.strategy,
              strategyType: val.strategyType,
              options: val.options,
              isEnabled: val.isEnabled,
              id: val.id
            })
          })
        }
        this.tableProps.dataext
      })
      .catch(err => {
        console.log('Error:', err);
      });
    },
    openDialog(row) {
      if (row) {
        console.log(row)
        this.name = row.name;
        this.tagName = row.tagName;
        this.selectedStrategy = row.strategy;
        this.selectedStrategyType = row.strategyType;
        this.authOptions = JSON.stringify(row.options);
        this.isNew = false;
        this.currentId = row.id;
      } else {
        this.name = null;
        this.tagName = null;
        this.selectedStrategy = null;
        this.selectedStrategyType = null;
        this.authOptions = null;
        this.isNew = true;
      }
      this.$refs.dialog.open();
    },
    closeDialog(isSaved) {
      if (isSaved && !this.isNew) {
        console.log('UPDATE ENDPOINT', this.currentRow);
        let data = {
          name: this.name,
          tagName: this.tagName,
          strategy: this.selectedStrategy,
          strategyType: this.selectedStrategyType,
          id: this.currentId,
          options: this.authOptions
        }

        try {
          data.options = JSON.parse(data.options);
        } catch (e) {
          console.log(e.message);
        }
        managedata.updateAuthConfig(data)
          .then(res=>{
            console.log(res)
            this.parseAuthConfigs();
            })
          .catch(err => {
            console.log('Error:', err);
          });
      } else if(isSaved && this.isNew){
        let data = {
          name: this.name,
          tagName: this.tagName,
          strategy: this.selectedStrategy,
          strategyType: this.selectedStrategyType,
          options: this.authOptions
        };

        try {
          data.options = JSON.parse(data.options);
        } catch (e) {
          console.log(e.message);
        }
        managedata.saveAuthConfig(data)
          .then(res=>{
            console.log(res)
            this.parseAuthConfigs();
            })
          .catch(err => {
            console.log('Error:', err);
          });
        console.log('SAVE ENDPOINT', this.name)
      }
      this.$refs.dialog.close();
      this.name = null;
      this.tagName = null;
      this.selectedStrategy = null;
      this.selectedStrategyType = null;
      this.authOptions = null;
    },
    openConfirmDialog(row) {
      this.currentRow = row;
      this.$refs.confirmDialog.open();
    },
    closeConfirmDialog(isConfirmed) {
      if (isConfirmed) {
        console.log('DELETE ENDPOINT', this.currentRow.id)
        managedata.deleteAuthConfig(this.currentRow.id)
          .then(res=>{
            console.log(res)
            this.parseAuthConfigs();
            })
          .catch(err => {
            console.log('Error:', err);
          });
      }
      this.$refs.confirmDialog.close();
    },
  },
  mounted() {
    this.parseAuthConfigs();
    this.strategyOptions = ['passport-azure-ad', 'passport-saml', 'passport-openidconnect']
    this.strategyTypeOptions = ['Strategy', 'OIDCStrategy']
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style>
  .md-dialog .md-input-container .multiselect__tags input, .md-dialog .md-input-container .multiselect__tags textarea {
    font-size: 14px;
  }
  .options.md-table-cell{
    max-width: 940px !important;
  }
</style>



// WEBPACK FOOTER //
// AuthorizationConfigurations.vue?48e8cb22